import { render, staticRenderFns } from "./VolunteerserviceCompile.vue?vue&type=template&id=60b43d9a&scoped=true"
import script from "./VolunteerserviceCompile.vue?vue&type=script&lang=js"
export * from "./VolunteerserviceCompile.vue?vue&type=script&lang=js"
import style0 from "./VolunteerserviceCompile.vue?vue&type=style&index=0&id=60b43d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b43d9a",
  null
  
)

export default component.exports